import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUploadShot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 25,
	viewBox: "0 0 26 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 5H0.5V22.5C0.5 23.875 1.625 25 3 25H20.5V22.5H3V5ZM23 0H8C6.625 0 5.5 1.125 5.5 2.5V17.5C5.5 18.875 6.625 20 8 20H23C24.375 20 25.5 18.875 25.5 17.5V2.5C25.5 1.125 24.375 0 23 0ZM23 17.5H8V2.5H23V17.5ZM14.25 15H16.75V11.25H20.5V8.75H16.75V5H14.25V8.75H10.5V11.25H14.25V15Z",
		fill: "#5E6068"
	})
});
export { SvgUploadShot as ReactComponent };
